import axios from 'axios'
import { getSessionToken } from '../session'
const CONTENT_SERVICE_API_URL = process.env.REACT_APP_CONTENT_SERVICE_API_URL

const GET = 'GET'
const POST = 'POST'
const DELETE = 'DELETE'
const PATCH = 'PATCH'

export const TYPE_PHENOMENON='phenomenon'
export const TYPE_SIGNAL='signal'
export const TYPE_SCENARIO='scenario'

async function httpRequest(method, path, payload = null) {
  return axios({
    method,
    url: `${CONTENT_SERVICE_API_URL}/${path}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getSessionToken()}`
    },
    withCredentials: true,
    data: payload || null
  }).then(({ data }) => data)
}

export async function getSchema({ group = 0, type }) {
  return httpRequest(GET, `schema/${group}/${type}`)
}

export async function getDocument({ group = 0, type, id }) {
  return httpRequest (GET, `doc/${group}/${type}/${id}`)
}

export async function archiveDocument({ group = 0, type, id }) {
  return httpRequest (DELETE, `doc/${group}/${type}/${id}`)
}

export async function getDocuments({ type, ids, fields = null, sortColumns = null }) {
  return httpRequest(POST, `doc/find/${type}`, { ids, fields, sortColumns })
}

export async function upsertDocument({ group, type, ...doc }) {
  if (doc.id) {
    return httpRequest(PATCH, `doc/${group}/${type}`, {groups: [Number(group)], type, ...doc})
  } else {
    return httpRequest(POST, `doc/${group}/${type}`, {groups: [Number(group)], type, ...doc})
  }
}

export async function getScenarioCards({ group = 0, id }) {
  return httpRequest (GET, `doc/scenario-set/${group}/${id}`)
}

